import type { ComponentType } from "react";
import {
    ChevronDown,
    ChevronUp,
    Hash,
    HelpCircle,
    Mail,
    Map,
    Menu,
    MoreHorizontal,
    Plus,
    Settings,
    User,
    Users,
    X,
} from "react-feather";

import type { IconName } from "./types";

export const iconsComponents: Record<IconName, ComponentType> = {
    contacts: Users,
    cross: X,
    plus: Plus,
    map: Map,
    "chevron-up": ChevronUp,
    "chevron-down": ChevronDown,
    help: HelpCircle,
    menu: Menu,
    more: MoreHorizontal,
    settings: Settings,
    users: User,
    email: Mail,
    anonymous: Hash,
};
